<style lang="scss" scoped>
@import '../css/main.scss';
</style>

<template>
  <div class="donga-audit">
    <audit-header></audit-header>
    <div class="audit-template main-template">
      <main role="main" class="audit-main">
        <div class="visual-top">
          <div class="col-container">
            <div class="visual-slogan">
              <h1>윤리경영 · 투명하고 공정하게</h1>
            </div>
            <h2 class="visual-tit">사이버 감사실은 제보자를 존중하며 <br class="pc-show">투명하고 공정하게 수행하겠습니다.</h2>
            <p class="visual-txt">기업의 사회적 책임과 윤리경영 실천을 위해 부정·비리 신고 채널을 운영하고 있으며, <br class="pc-show">제보 내용은 관련 법령에 따라 철저히 비밀이 보장됩니다.</p>
          </div>
        </div>
        <div id="main-sections">
          <div class="main-banner">
            <div class="title-wrap">
              <h1>REPORT SCOPE</h1>
              <span class="sub-title">제보대상</span>
              <span class="sub-content">아래 항목에 해당하는 부정·비리 행위를 제보해 주세요.</span>
            </div>
            <div class="banner-wrap">
              <div class="banner-row">
                <div class="banner-item">
                  <img src="../img/ico_handshack_money.png" alt="금품·향응 수수"/>
                  <span class="item-title">금품·향응 수수</span>
                  <span class="item-content">직무와 관련해 이해관계자로부터<br>금품 또는 향응을 수수하는 행위</span>
                </div>
                <div class="banner-item">
                  <img src="../img/ico_handshack_file.png" alt="불공정 거래행위"/>
                  <span class="item-title">불공정 거래행위</span>
                  <span class="item-content">거래 회사의 불공정한 선정, 기타<br>CP 위반행위</span>
                </div>
                <div class="banner-item">
                  <img src="../img/ico_user_arrow.png" alt="우월적 지위 남용"/>
                  <span class="item-title">우월적 지위 남용</span>
                  <span class="item-content">지위를 이용한 불합리한 요구 및<br>관계사 불공정행위</span>
                </div>
                <div class="banner-item">
                  <img src="../img/ico_building_arrowmoney.png" alt="횡령·자산 부당사용"/>
                  <span class="item-title">횡령·자산 부당사용</span>
                  <span class="item-content">회사비용 유용 및 회사자산의<br>불법·부당 사용</span>
                </div>
              </div>
              <div class="banner-row">
                <div class="banner-item">
                  <img src="../img/ico_user_relation.png" alt="직장 내 괴롭힘·성희롱"/>
                  <span class="item-title">직장 내 괴롭힘·성희롱</span>
                  <span class="item-content">폭행, 괴롭힘, 성희롱 등<br>근무기강 해이 관련 사항</span>
                </div>
                <div class="banner-item">
                  <img src="../img/ico_profilecard_exclamationmark.png" alt="인사 관련 불만"/>
                  <span class="item-title">인사 관련 불만</span>
                  <span class="item-content">채용, 인력유출 등<br>인사 관련 불만 사항</span>
                </div>
                <div class="banner-item">
                  <img src="../img/ico_file_lock.png" alt="정보 유출"/>
                  <span class="item-title">정보 유출</span>
                  <span class="item-content">기술자료, 영업비밀, 개인정보 등<br>회사 관련 정보 유출</span>
                </div>
                <div class="banner-item">
                  <img src="../img/ico_speechbubble_pen.png" alt="기타 비윤리 행위·제안"/>
                  <span class="item-title">기타 비윤리 행위·제안</span>
                  <span class="item-content">직무 관련 비윤리적 행위 및<br>각종 제안·제보</span>
                </div>
              </div>
            </div>
          </div>
          <div class="report-area">
            <div class="report-title-wrap">
              <h1>제보가 필요하신가요?</h1>
              <span>모든 제보는 암호화되어 안전하게 접수되며, 신고자는 신분 노출 없이 보호받습니다.</span>
            </div>
            <div class="report-btn">
              <a class="btn-item">
                <img class="img-info" src="../img/ico_file_circle_exclamation.png" alt="제보안내"/>
                <div class="btn-text">
                  <span>제보안내</span>
                  <img src="../img/ico-left-arrow.png" alt="바로가기 화살표"/>
                </div>
              </a>
              <a class="btn-item">
                <img class="img-info" src="../img/ico_paper_plane.png" alt="제보하기"/>
                <div class="btn-text">
                  <span>제보하기</span>
                  <img src="../img/ico-left-arrow.png" alt="바로가기 화살표"/>
                </div>
              </a>
              <a class="btn-item">
                <img class="img-info" src="../img/ico_file_circle_check.png" alt="제보확인"/>
                <div class="btn-text">
                  <span>제보확인</span>
                  <img src="../img/ico-left-arrow.png" alt="바로가기 화살표"/>
                </div>
              </a>
            </div>
          </div>
          <div class="audit-info">
            <img src="../img/Ico_circle_exclamation.png" alt="알림"/>
            <span>무고, 근거 없는 비방 등 사실이 아닌 내용은 제보대상이 아니며, 이러한 제보는 조사가 진행되지 않거나<br>처리 과정에서 추가 확인을 위한 질문을 드릴 수 있습니다.</span>
          </div>
        </div>
      </main>
    </div>
    <audit-footer></audit-footer>
  </div>
</template>
<script>
import AuditHeader from '@/components/AuditHeader'
import AuditFooter from '@/components/AuditFooter'
export default {
  name: 'Main',
  components: {
    'audit-header': AuditHeader,
    'audit-footer': AuditFooter
  },
  created () {
    this.openMsgBox() // popup on/off
    // this.openMsgBox2() // popup on/off
  },
  methods: {
    getCookie (cookieName) {
      var isCookie = false
      var start, end
      var i = 0

      // cookie 문자열 전체를 검색
      while (i <= document.cookie.length) {
        start = i
        end = start + cookieName.length
        // cookie_name과 동일한 문자가 있다면
        if (document.cookie.substring(start, end) === cookieName) {
          isCookie = true
          break
        }
        i++
      }

      // cookie_name 문자열을 cookie에서 찾았다면
      if (isCookie) {
        start = end + 1
        end = document.cookie.indexOf(';', start)
        // 마지막 부분이라는 것을 의미(마지막에는 ";"가 없다)
        if (end < start) {
          end = document.cookie.length
        }
        // cookie_name에 해당하는 value값을 추출하여 리턴한다.
        return document.cookie.substring(start, end)
      }
      // 찾지 못했다면
      return ''
    },
    openMsgBox () {
      /* *
       * sDate, eDate
       * AS-IS yyyy-MM-dd
       * TO-BE yyyy-MM-dd HH:mm:ss
       *
       * YYYY-MM-DD만 선언 돼 있으면 09:00:00 default
       * 파일 선반영하여 특정시간에 띄우기 위해 시간 추가
       * 익스플로러에서 hhmmss 포맷형식이 안먹히는 현상이 있어 replace 처리
       * */
      var today = new Date()
      // var sDate = '2025-12-22 08:00:00' // 해당 일부터 팝업 on
      // var eDate = '2026-01-05 08:00:00' // 해당 일부터 팝업 off
      var sDate = '2026-07-28 08:00:00' // 해당 일부터 팝업 on
      var eDate = '2026-08-10 08:00:00' // 해당 일부터 팝업 off

      today = new Date(today.getTime() - (today.getTimezoneOffset() * 60000)).toISOString().replace(/T/, ' ').replace(/\..+/, '')
      sDate = sDate.replace(/T/, ' ').replace(/\..+/, '')
      eDate = eDate.replace(/T/, ' ').replace(/\..+/, '')

      if (today < sDate || today > eDate) {
        return false
      }
      var left = 10 + window.screenLeft
      var eventCookie = this.getCookie('popupname')
      // 쿠키가 없을 경우에만 (다시 보지 않기를 선택하지 않았을 경우.)
      if (eventCookie !== 'done') {
        if (navigator.userAgent.indexOf('Chrome') > -1) {
          window.open('/auditpopup', 'popup01', 'left=' + left + ', top=10, width=645, height=880, scrollbars= 0, toolbar=0, menubar=no')
        } else {
          window.open('/auditpopup', 'popup01', 'left=' + left + ', top=10, width=645, height=880, scrollbars= 0, toolbar=0, menubar=no')
        }
      }
    }
    // openMsgBox2 () {
    //   var eventCookie = this.getCookie('popupname2')
    //   // 쿠키가 없을 경우에만 (다시 보지 않기를 선택하지 않았을 경우.)
    //   if (eventCookie !== 'done') {
    //     if (navigator.userAgent.indexOf('Chrome') > -1) {
    //       window.open('/auditpopup2', 'popup02', 'left=500, top=10, width=586, height=415, scrollbars= 0, toolbar=0, menubar=no')
    //     } else {
    //       window.open('/auditpopup2', 'popup02', 'left=500, top=10, width=586, height=420, scrollbars= 0, toolbar=0, menubar=no')
    //     }
    //   }
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Main.vue